<template>
  <v-container fluid class="hide-for-inspection-sheet">
    <v-dialog
        v-model="viewSheet"
        fullscreen
        hide-overlay
        transition="scale-transition"
    >
      <InspectionSheet
          v-if="viewSheet"
          :inspection-id="inspectionId"
          @close="viewSheet = false"
      ></InspectionSheet>
    </v-dialog>
    <v-dialog
        :value="showWhatsNew"
        persistent
        :fullscreen="$vuetify.breakpoint.smAndDown"
        width="600"
        @input="setShowWhatsNew(false)"
    >
      <AppWhatsNew
          @close="setShowWhatsNew(false)"
      ></AppWhatsNew>
    </v-dialog>
    <v-card elevation="1">
      <v-card-text class="pb-0 pb-sm-4 pt-0">
        <div class="d-sm-flex justify-space-between align-end">
          <div class="flex-grow-1 flex-lg-grow-0">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="Search"
                single-line
            ></v-text-field>
          </div>
          <v-btn-toggle
              v-model="pastOrFuture"
              class="ml-sm-2 mt-4 mt-sm-0"
              color="primary"
              mandatory
          >
            <v-btn small text>
              <v-icon small class="current-color mr-1">mdi-calendar-arrow-left</v-icon> Past
            </v-btn>
            <v-btn small text>
              <v-icon small class="current-color mr-1">mdi-calendar-arrow-right</v-icon> Future
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-card-text>
      <v-data-table
          id="inspection-list"
          :footer-props="{'items-per-page-options': [10, 25, 50]}"
          :headers="headers"
          :items="inspections"
          :loading="loading"
          :options.sync="options"
          :search="search"
          :server-items-length="totalInspections"
          class="logs"
          dense
      >
        <template v-slot:item.datetime="{ item }">
          <div><AppMultilineText :value="dateTimeFormat(item.datetime)"/></div>
        </template>
        <template v-slot:item.full_address="{ item }">
          <div><AppMultilineText :value="item.full_address"/></div>
        </template>
        <template v-slot:item.inspectors="{ item }">
          <div v-for="(inspector, i) in item.inspectors" :key="i">{{ inspector }}<br></div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
              x-small
              class="mr-1"
              @click="openLogsModal(item.id)"
          >
            <v-icon small>mdi-text-search</v-icon> Logs
          </v-btn>
          <v-btn
              color="primary"
              x-small
              class="mr-1"
              @click="openSheetModal(item.id)"
          >
            <v-icon small>mdi-file-find</v-icon> View
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
        v-model="viewLogs"
        fullscreen
        hide-overlay
        transition="scale-transition"
    >
      <InspectionLogs
          v-if="viewLogs"
          :inspection-id="inspectionId"
          :dateTimeFormat="dateTimeFormat"
          @close="viewLogs = false"
      ></InspectionLogs>
    </v-dialog>
  </v-container>
</template>

<script>
import format from 'date-fns/format'
import parseISO from "date-fns/parseISO";
import {mapGetters, mapMutations} from 'vuex'
import debounce from 'underscore/modules/debounce.js'
import AppMultilineText from '@/components/AppMultilineText'
const AppWhatsNew = () => import('./AppWhatsNew')
const InspectionSheet = () => import('./InspectionSheet')
const InspectionLogs = () => import('./InspectionLogs')

export default {
  name: 'InspectionList',
  components: {InspectionLogs, InspectionSheet, AppWhatsNew, AppMultilineText},
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 25,
      },
      loading: false,
      search: '',
      viewSheet: false,
      viewLogs: false,
      inspectionId: null,
      headers: [
        {text: 'Date/Time',       value: 'datetime',     sortable: false, width: '11%'},
        {text: 'Address',         value: 'full_address', sortable: false, width: '18%'},
        {text: 'Client',          value: 'client',       sortable: false, width: '12%'},
        {text: 'Buyer\'s Agent',  value: 'buyer_agent',  sortable: false, width: '12%'},
        {text: 'Seller\'s Agent', value: 'seller_agent', sortable: false, width: '12%'},
        {text: 'Inspectors',      value: 'inspectors',   sortable: false, width: '12%'},
        {text: 'Total',           value: 'fee_total',    sortable: false, width: '5%'},
        {text: '',                value: 'actions',      sortable: false, width: '18%' , align: 'end'},
      ],
      pastOrFuture: 1,
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser',
      showWhatsNew: 'showWhatsNew',
    }),
    inspections() {
      return this.$store.getters.getInspections.data || []
    },
    totalInspections() {
      return this.$store.getters.getInspections?.meta?.total || 0
    },
    when() {
      return ['past', 'future'][this.pastOrFuture]
    },
  },
  watch: {
    options: {
      handler () {
        this.retrieveInspections()
      },
      deep: true,
    },
    search: debounce(function (value) {
      this.search = value
      this.retrieveInspections()
    }, 500),
    pastOrFuture() {
      this.options.page = 1
      this.retrieveInspections()
    },
    viewSheet(value) {
      this.setInspectionSheetOpen(value)
    }
  },
  methods: {
    ...mapMutations(['setInspectionSheetOpen', 'setShowWhatsNew']),
    retrieveInspections() {
      if (this.loading) {
        return
      }
      this.loading = true
      const payload = {options: this.options, search: this.search, when: this.when}
      this.$store.dispatch('retrieveInspections', payload)
          .then(() => this.loading = false)
    },
    dateTimeFormat(datetime) {
      try {
        return format(parseISO(datetime), 'ccc, h:mmaaaaa_MM/dd/yyyy').replace(/_/, '<br>')
      } catch (e) {
        console.log(e)
      }

      console.log('Error formatting ' + datetime)
      return datetime
    },
    openSheetModal(inspectionId) {
      this.inspectionId = inspectionId
      this.viewSheet = true
    },
    openLogsModal(inspectionId) {
      this.inspectionId = inspectionId
      this.viewLogs = true
    },
  },
}
</script>

<style>
@media only screen and (max-width: 599px) {
  .logs > div > table > tbody {
    display: block !important;
  }
}
@media only screen and (min-width: 600px) {
  #inspection-list td {
    font-size: 0.625rem;
  }
}
</style>

<style scoped>
.current-color {
  color: currentColor !important;
}
</style>